import React, { useEffect, useRef, useState } from 'react';
import styles from './register.module.css';
import constant from '../../../constant';
import { getsessionStorage, setsessionStorage } from '../../../utils';
import { toast } from 'react-toastify';
import { resentRegistrationOtp } from '../../../action/auth';

const StepTwo = ({ length = 6, onSubmit }) => {
    const [otp, setOtp] = useState('');
    const [error, setError] = useState(false);
    const inputsRef = useRef([]);
    const [timeLeft, setTimeLeft] = useState(180);
    const onChange = (value) => {
        setOtp(value);
        if (value.length === length) {
            setError(false); // Clear error if OTP is valid
        }
    };
    // Countdown timer
    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft((prevTime) => {
                if (prevTime > 0) {
                    return prevTime - 1;
                } else {
                    clearInterval(timer);
                    return 0;
                }
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);
    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
    };
    const handleInputChange = (e, index) => {
        const { value } = e.target;

        // Allow only numeric values
        if (!/^\d*$/.test(value)) return;

        // Trigger onChange with the OTP value
        const otpValue = inputsRef.current.map((input) => input?.value || '').join('');
        onChange(otpValue);

        // Move to the next input if a number is entered
        if (value && index < length - 1) {
            inputsRef.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !inputsRef.current[index].value && index > 0) {
            // Move to the previous input on Backspace
            inputsRef.current[index - 1]?.focus();
        }
    };

    const handlePaste = (e) => {
        const pastedData = e.clipboardData.getData('text').slice(0, length);
        const otpArray = pastedData.split('');
        otpArray.forEach((char, index) => {
            if (inputsRef.current[index]) {
                inputsRef.current[index].value = char;
            }
        });

        // Trigger onChange with the pasted OTP value
        const otpValue = inputsRef.current.map((input) => input?.value || '').join('');
        onChange(otpValue);
    };

    const handleSubmit = () => {
        if (otp.length === length) {
            setError(false);
            const storage = getsessionStorage(constant.keys.registration_ref);
            onSubmit({ otp, ref_code: storage.ref_code });
        } else {
            setError(true);
        }
    };
    const resendOtp = () => {
        debugger
        const storage = getsessionStorage(constant.keys.registration_ref);
        resentRegistrationOtp({ ref_code: storage.ref_code }).then((res) => {
            if (res.status) {
                setsessionStorage(constant.keys.registration_ref, ({ step: 2, ref_code: res.result.ref_code }))
                toast.success('otp resended')
            }
        })
    }

    return (
        <React.Fragment>
            <div className={`${styles['otp-box']} card`}>
                <div className={`${styles['reg-body']} card-body`}>
                    <h5 className={`${styles['reg-title']}`}>Verify OTP</h5>
                    <p className={`${styles['reg-text']}`}>
                        We've sent an OTP to your mobile.
                    </p>
                    <div
                        className={`${styles['code-input']} my-4 ${error ? `${styles['otp-is-invalid']}` : ''
                            }`}
                        onPaste={handlePaste}
                    >
                        {Array.from({ length }).map((_, index) => (
                            <input
                                key={index}
                                type="text"
                                maxLength="1"
                                ref={(el) => (inputsRef.current[index] = el)}
                                onChange={(e) => handleInputChange(e, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                            />
                        ))}
                    </div>
                    {error && (
                        <p className="error-message">
                            Please fill all OTP fields correctly.
                        </p>
                    )}
                    <p className={`${styles['otp-text']} text-center mb-5`}>
                        Didn't receive? <strong>
                            {timeLeft > 0
                                ? `Resend in ${formatTime(timeLeft)}`
                                : <a href='javascript:void(0);' onClick={resendOtp}>'You can resend now!'</a>}
                        </strong>
                    </p>
                    <button
                        className={`${styles['send-btn']} btn`}
                        onClick={handleSubmit}
                    >
                        Verify
                    </button>
                </div>
            </div>
        </React.Fragment>
    );
};

export default StepTwo;
